module.exports = __webpack_public_path__ + "img/changePasswordicon.37b23d7c.svg";